import firebase from "firebase";
import { db, auth } from "../../Firebase/firebase";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import router from "../../router/index";
import { Date } from "core-js";
import Vue from "vue";
import { baseurl } from "../../helpers/helper";

const increment = firebase.firestore.FieldValue.increment(1);
const decrement = firebase.firestore.FieldValue.increment(-1);

export default {
  namespaced: true,
  state: {
    cart: {},
  },

  mutations: {
    ADD_TO_CART(state, { item, currentMenu }) {
      if (!state.cart[currentMenu]) {
        Vue.set(state.cart, currentMenu, {});
      }
      if (!state.cart[currentMenu][item.id]) {
        Vue.set(state.cart[currentMenu], item.id, {});
        state.cart[currentMenu][item.id] = { ...item, quantity: 1 };
      } else {
        state.cart[currentMenu][item.id] = {
          ...state.cart[currentMenu][item.id],
          quantity: state.cart[currentMenu][item.id].quantity + 1,
        };
      }

      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    ADD_BULK_TO_CART(state, { item, currentMenu }) {
      if (!state.cart[currentMenu]) {
        Vue.set(state.cart, currentMenu, {});
      }
      if (!state.cart[currentMenu][item.id]) {
        Vue.set(state.cart[currentMenu], item.id, {});
        state.cart[currentMenu][item.id] = { ...item };
      } else {
        state.cart[currentMenu][item.id] = {
          ...state.cart[currentMenu][item.id],
          quantity: state.cart[currentMenu][item.id].quantity + 1,
        };
      }

      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    REDUCE_QUANTITY(state, { item, currentMenu }) {
      if (state.cart[currentMenu][item.id].quantity < 2) {
        let newCart = state.cart[currentMenu];
        delete newCart[item.id];
        state.cart[currentMenu] = { ...newCart };
      } else {
        state.cart[currentMenu][item.id] = {
          ...state.cart[currentMenu][item.id],
          quantity: state.cart[currentMenu][item.id].quantity - 1,
        };
      }
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    REMOVE_FROM_CART(state, { item, currentMenu }) {
      let newCart = state.cart[currentMenu];
      delete newCart[item.id];
      state.cart[currentMenu] = { ...newCart };
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    SET_CART(state, item) {
      state.cart = JSON.parse(item);
    },
    CLEAR_CART(state) {
      state.cart = {};
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
  },

  getters: {
    cartTotal(state) {
      return (currentMenu) => {
        const total = Object.values(state.cart[currentMenu]).reduce(
          (total, { quantity, price }) => total + quantity * price,
          0
        );
        return total;
      };
    },
  },

  actions: {
    addToCart({ commit, rootState }, item) {
      const currentMenu = rootState.MenuView.currentMenu.id;
      commit("ADD_TO_CART", { item, currentMenu });
    },
    addBulkToCart({ commit, rootState }, items) {
      const currentMenu = rootState.MenuView.currentMenu.id;
      items.map((item) => {
        commit("ADD_BULK_TO_CART", { item, currentMenu });
      });
    },
    reduceQuantity({ commit, rootState }, item) {
      const currentMenu = rootState.MenuView.currentMenu.id;
      return commit("REDUCE_QUANTITY", { item, currentMenu });
    },
    async setCart({ commit }, item) {
      if (item) {
        commit("SET_CART", item);
      }
      return Promise.resolve();
    },
  },
};
